import React from "react";
import { QuestionAnswerDynamicZoneModel } from "@models/strapi-components/question-answer";
import Title from "@components/common/Title";

export interface QuestionAnserPropsModel {
  componentData: QuestionAnswerDynamicZoneModel;
}

const QuestionAnswer: React.FunctionComponent<QuestionAnserPropsModel> = ({
  componentData,
}) => {
  const {
    questionTitle,
    questionSubtitle,
    answerTitle,
    answerSubtitle,
    questionFontColor,
    questionBgColor,
    answerFontColor,
    answerBgColor,
  } = componentData ?? {};
  return (
    <div className="min-h-[600px] px-[20px] py-[50px] sm:px-[50px] lg:max-xl:px-[70px] lg:max-xl:py-[60px] xl:px-[90px] xl:py-[80px] flex justify-center">
      <div
        className=" min-h-[440px] max-w-[500px] lg:max-w-none rounded-3xl flex flex-col lg:flex-row items-center py-[40px] lg:py-0"
        style={{
          backgroundColor: questionBgColor ?? "#291E30",
        }}
      >
        <div className="text-white w-3/4 lg:w-1/2 lg:px-[70px] pb-8 lg:pb-0">
          <div className="lg:min-h-[380px] max-w-[600px] flex flex-col justify-center">
            <Title
              variant="h2"
              titleText={questionTitle}
              style={{ color: questionFontColor ?? "#FFFFFF" }}
            />
            <Title
              variant="paragraph"
              titleText={questionSubtitle}
              style={{ color: questionFontColor ?? "#FFFFFF" }}
            />
          </div>
        </div>
        <div className="w-3/4 lg:w-1/2 flex justify-center px-[30px]">
          <div
            className="lg:min-h-[380px] min-w-[280px] min-[400px]:max-[450px]:min-w-[320px] min-[450px]:max-[480px]:min-w-[350px]  min-[480px]:max-[500px]:min-w-[380px] min-[500px]:min-w-[400px] max-w-[600px] px-[20px] sm:px-[40px] rounded-3xl flex flex-col justify-center py-8 lg:py-0"
            style={{ backgroundColor: answerBgColor ?? "#CCF9C2" }}
          >
            <Title
              variant="h2"
              titleText={answerTitle}
              style={{ color: answerFontColor ?? "#291E30" }}
            />
            <Title
              variant="paragraph"
              titleText={answerSubtitle}
              style={{ color: answerFontColor ?? "#291E30" }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default QuestionAnswer;
